import React, { useState, useEffect } from "react"
import { TextField } from "@material-ui/core"
import { useField } from "formik"
import NumberFormat from "react-number-format"

const PhoneInput = ({
  name,
  format,
  startAdornment,
  endAdornment,
  defaultValue,
  ...rest
}) => {
  const [field, meta, helpers] = useField(name)

  const handleBlur = () => {
    if (!meta.touched) {
      helpers.setTouched(true)
    }
  }

  return (
    <NumberFormat
      format="(###) ###-####"
      mask="_"
      variant="filled"
      allowEmptyFormatting
      customInput={TextField}
      margin="normal"
      name={field.name}
      value={field.value}
      displayType="input"
      error={meta.touched && meta.error}
      helperText={(meta.touched && meta.error) || ""}
      allowLeadingZeros={false}
      InputProps={{ startAdornment, endAdornment }}
      InputLabelProps={{ shrink: true }}
      isNumericString
      onValueChange={val => {
        helpers.setValue(val.value)
      }}
      inputProps={{
        onBlur: handleBlur,
      }}
      {...rest}
    />
  )
}

export { PhoneInput }
